import verificationCodeInputInit from './input.verificationcode';

export default () => {
  verificationCodeInputInit();
}
